import React, { useState } from 'react';

const LiquefactionAssessmentLegend = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const legendStyle = {
    position: 'absolute',
    bottom: '10px',
    right: '10px',
    backgroundColor: 'white',
    padding: '10px',
    borderRadius: '5px',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
    zIndex: 1000, // 맵 위에 보이도록 z-index 설정
  };

  const legendItemStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
  };

  const colorBoxStyle = (color) => ({
    width: '20px',
    height: '20px',
    backgroundColor: color,
    marginRight: '10px',
  });

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    marginBottom: isExpanded ? '10px' : '0',
  };

  return (
    <div style={legendStyle}>
      <div style={headerStyle} onClick={() => setIsExpanded(!isExpanded)}>
        <h4 style={{ fontWeight:'bold', margin: 0 }}>액상화 예비 평가</h4>
        <span style={{ marginLeft: '10px', fontSize: '14px' }}>{isExpanded ? '▼' : '▶'}</span>
      </div>
      {isExpanded && (
        <>
          <div style={legendItemStyle}>
            <div style={colorBoxStyle('gray')}></div>
            <span>알 수 없음 (회색)</span>
          </div>
          <div style={legendItemStyle}>
            <div style={colorBoxStyle('green')}></div>
            <span>안전 (초록색)</span>
          </div>
          <div style={legendItemStyle}>
            <div style={colorBoxStyle('red')}></div>
            <span>평가 필요 (빨간색)</span>
          </div>
        </>
      )}
    </div>
  );
};

export default LiquefactionAssessmentLegend;